var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress } from "@mui/material";
import PropTypes from "prop-types";
import { StyledButton } from "./va-button-style";
const VaButton = (props) => {
    const { label, color = "primary", round, loading = false, addShadow = false, py = "primary", width = 0, height = 0, fullWidth = false } = props, otherProps = __rest(props, ["label", "color", "round", "loading", "addShadow", "py", "width", "height", "fullWidth"]);
    return (_jsxs(StyledButton, Object.assign({ variant: "contained", round: round ? 1 : 0, color: color, disabled: loading, shadow: addShadow ? 1 : 0, width: width, height: height, py: py }, otherProps, { children: [loading && _jsx(CircularProgress, { size: "small" }), " ", label] })));
};
VaButton.propTypes = {
    label: PropTypes.string,
    color: PropTypes.string,
    round: PropTypes.bool,
    loading: PropTypes.bool,
    addShadow: PropTypes.bool,
    py: PropTypes.string,
    width: PropTypes.string,
    id: PropTypes.string, // 👈 added
    type: PropTypes.string, // 👈 added if needed
    fullWidth: PropTypes.bool,
};
export default VaButton;
